import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Pages.css"; // Ensure this is only imported once
import { easyparagraphs, Shufflepara, hardparagraphs, challenge } from '../Components/Paragraphs';
import NavBtns from '../Components/NavBtns';

// Image imports
import easyImage from "../assets/easy.jpeg";
import hardImage from "../assets/Hard.jpeg";
import challengeImage from "../assets/challenge.jpeg";
import shuffleImage from "../assets/shuffle.jpeg";
import timeImage from "../assets/time.jpeg";
import errorImage from "../assets/error.jpeg";
import endImage from "../assets/end.jpeg";

// Difficulty levels data
const difficulties = [
  {
    level: 'Easy Mode',
    paragraphs: easyparagraphs,
    description: 'Try speed typing test with easy words.',
    time: '9 mins',
    imgSrc: easyImage
  },
  {
    level: 'Hard Mode',
    paragraphs: hardparagraphs,
    description: 'Try speed typing test with hard words.',
    time: '15 mins',
    imgSrc: hardImage
  },
  {
    level: 'Challenge Mode',
    paragraphs: challenge,
    description: 'Type a passage that includes a mixture of numbers, symbols, and letters.',
    time: '15 mins',
    imgSrc: challengeImage
  },
  {
    level: 'Shuffle Mode',
    paragraphs: Shufflepara,
    description: 'Try speed typing test with shuffled words.',
    time: '15 mins',
    imgSrc: shuffleImage
  },
];

// Mode data
const modes = [
  {
    name: 'Time Attack Mode',
    description: 'Type as many words as possible within a limited time frame: 30, 60 & 90 seconds.',
    link: '/timeattack',
    imgSrc: timeImage
  },
  {
    name: 'Survival Mode',
    description: 'Type continuously without a time limit until you make a certain number of errors.',
    link: '/errormode',
    imgSrc: errorImage
  },
  {
    name: 'Sudden Death Mode',
    description: 'Type without making any errors. One mistake ends the session.',
    link: '/survivalmode',
    imgSrc: endImage
  },
];

const Explore = () => {
  const navigate = useNavigate();

  const handlePlayNow = (selectedParagraphs) => {
    navigate('/playNow', { state: { paragraphs: selectedParagraphs } });
  };

  return (
    <>
      <NavBtns />
      <div className="explore-container"> {/* Add a top-level container class for better styling control */}

        {/* Modes Section */}
        <div className="album py-5 bg-body-tertiary">
          <div className="container">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
              {modes.map((mode, index) => (
                <div className="col" key={index}>
                  <div className="card shadow-sm">
                    <img
                      className="bd-placeholder-img card-img-top"
                      src={mode.imgSrc}
                      alt={mode.name}
                      width="100%"
                      height="225"
                      style={{ objectFit: 'cover' }}
                    />
                    <div className="card-body">
                      <h3>{mode.name}</h3>
                      <p className="card-text" style={{ marginLeft: "5px", marginRight: "5px" }}>
                        {mode.description}
                      </p>
                     
                        <Link to={mode.link} className="playnowbutton " style={{ color: "white", textDecoration: "none" }}>
                          Play Now
                        </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Difficulties Section */}
        <div className="album py-5 bg-body-tertiary">
          <div className="container">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
              {difficulties.map((difficulty, index) => (
                <div className="col" key={index}>
                  <div className="card shadow-sm">
                    <img
                      className="bd-placeholder-img card-img-top"
                      src={difficulty.imgSrc}
                      alt={difficulty.level}
                      width="100%"
                      height="225"
                      style={{ objectFit: 'cover' }}
                    />
                    <div className="card-body">
                      <h3>{difficulty.level}</h3>
                      <p className="card-text" style={{ marginLeft: "5px", marginRight: "5px" }}>
                        {difficulty.description}
                      </p>    
                        <button
                          type="button"
                          className="playnowbutton " 
                          style={{ color: "white" }}
                          onClick={() => handlePlayNow(difficulty.paragraphs)}
                        >
                          Play Now
                        </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Explore;
